import * as React from 'react';
import type { ConnectorType } from '../../../../app/ApiGen';
import type { InputComponentProps } from '../../../../design-system';
import { type MenuOption, SelectionMenu } from '../../../SelectionMenu';

const options: MenuOption<ConnectorType>[] = [
  { label: 'CHAdeMO, DC', value: 'CHADEMO' },
  { label: 'IEC 62196 Type 1', value: 'IEC_62196_T1' },
  { label: 'Combo Type 1 based, DC', value: 'IEC_62196_T1_COMBO' },
  { label: 'IEC 62196 Type 2', value: 'IEC_62196_T2' },
  { label: 'Combo Type 2 based, DC', value: 'IEC_62196_T2_COMBO' },
  { label: 'IEC 62196 Type 3A', value: 'IEC_62196_T3A' },
  { label: 'IEC 62196 Type 3C', value: 'IEC_62196_T3C' },
];

export const StandardInput: React.FC<InputComponentProps<ConnectorType>> = ({
  disabled,
  error,
  helperText,
  onBlur,
  onChange,
  name,
  value,
}) => (
  <SelectionMenu
    aria-label="Standard"
    disabled={disabled}
    error={error}
    helperText={helperText}
    name={name}
    onBlur={onBlur}
    onChange={onChange}
    options={options}
    value={value}
  />
);
